export default {
  en: {
    dayparts: 'Dayparts',
    daypart: 'Daypart',
    'daypart-breakfast': 'Breakfast',
    'daypart-dinner': 'Dinner',
    'daypart-evening': 'Evening',
    'daypart-lunch': 'Lunch',
    'daypart-snack': 'Snack',
    'daypart-late_night': 'Late Night',
    peaks: 'Peaks',
    'time-slices': 'Time Slices',
    'time-slice-time': 'Time',
    'delete-time-slice': 'Delete Time Slice',
    'delete-time-slice-confirm':
      'Are you sure you want to delete this time slice? This action cannot be undone.',
    scope: 'Scope',
    'scope-enterprise': 'Enterprise',
    'scope-org': 'Organization',
    'scope-user': 'Personal',
  },
  es: {
    dayparts: 'Partes del día',
    daypart: 'Parte del día',
    'daypart-breakfast': 'Desayuno',
    'daypart-dinner': 'Cena',
    'daypart-evening': 'Noche',
    'daypart-lunch': 'Almuerzo',
    'daypart-snack': 'Merienda',
    'daypart-late_night': 'Madrugada',
    peaks: 'Picos',
    'time-slices': 'Franjas Horarias',
    'time-slice-time': 'Hora',
    'delete-time-slice': 'Eliminar Franja Horaria',
    'delete-time-slice-confirm':
      '¿Está seguro de que desea eliminar esta franja horaria? Esta acción no se puede deshacer.',
    scope: 'Alcance',
    'scope-enterprise': 'Empresa',
    'scope-org': 'Organización',
    'scope-user': 'Personal',
  },
};
